"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComplexGatewayViewModel = void 0;
const GatewayBaseViewModel_1 = require("./GatewayBaseViewModel");
class ComplexGatewayViewModel extends GatewayBaseViewModel_1.GatewayViewModel {
}
exports.ComplexGatewayViewModel = ComplexGatewayViewModel;
//# sourceMappingURL=ComplexGatewayViewModel.js.map